import React from 'react';
import {
  Create,
  SimpleForm,
  required,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
} from 'react-admin';

const redirectToReglaEditPrestacionGrupoReglaTab = (basePath, id, data) => `/grupo-regla/${data.idGrupoRegla}/1`;

const PrestacionGrupoReglaCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect={redirectToReglaEditPrestacionGrupoReglaTab}>
      <ReferenceInput
        source="idGrupoRegla"
        reference="grupo-regla"
        label="resources.grupo-regla-prestaciones.fields.grupo-regla"
        validate={[required()]}
      >
        <SelectInput optionText="descripcion" optionValue="id" options={{ disabled: true }}/>
      </ReferenceInput>
      <ReferenceInput
        source="idPrestacion"
        reference="prestaciones"
        label="resources.grupo-regla-prestaciones.fields.prestacion"
        sort={{ field: "descripcion", order: "ASC" }}
        perPage={100}
        filterToQuery={(searchText) => ({
          descripcion: searchText ? searchText : "",
        })}
        validate={[required()]}
      >
        <AutocompleteInput optionText="descripcion" optionValue="id" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export default PrestacionGrupoReglaCreate;
